import StolenModeMap from "../components/Map/StolenModeMap";

const StolenMode = (props) => {
    return (
		<>
            <StolenModeMap />
		</>
	);
};

export default StolenMode;
